import {Grid, Stack} from '@mui/material';
import React, {useEffect, useMemo} from 'react';
import {FieldsRendererProps} from '..';
import {AppControlledAutoComplete, AppControllerAutoCompleteMulti} from 'components/form';

interface RenderSelectProps extends FieldsRendererProps {
    gridSize?: number;
    isLoading?: boolean;
}

export const RenderSelect: React.FC<RenderSelectProps> = ({
    field,
    control,
    baseFieldName,
    gridSize,
    setValue,
    isLoading,
}) => {
    const defaultValue = useMemo(() => {
        try {
            return field.defaultValue?.options ?? [];
        } catch (error) {
            console.error('Error parsing default value', error);
            return [];
        }
    }, [field.defaultValue]);

    useEffect(() => {
        if (field.isMultiValue) {
            if (field.value.multiSelectedOptions && field.value.multiSelectedOptions.length > 0) {
                setValue(`${baseFieldName}.multiSelectedOptions`, field.value.multiSelectedOptions);
            }
        } else {
            if (field.value.selectedOption) {
                setValue(`${baseFieldName}.selectedOption`, field.value.selectedOption);
            }
        }
    }, [field.value.selectedOption]);

    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                {field.isMultiValue ? (
                    <AppControllerAutoCompleteMulti
                        label={field.title}
                        loading={isLoading}
                        required={field.isRequired}
                        disableClearable={field.isRequired ? true : undefined}
                        control={control}
                        defaultValue={field.value.multiSelectedOptions}
                        name={`${baseFieldName}.multiSelectedOptions`}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        options={defaultValue}
                    />
                ) : (
                    <AppControlledAutoComplete
                        label={field.title}
                        loading={isLoading}
                        required={field.isRequired}
                        disableClearable={field.isRequired ? true : undefined}
                        control={control}
                        defaultValue={field.value.selectedOption}
                        name={`${baseFieldName}.selectedOption`}
                        isOptionEqualToValue={(option, value) => option.value === value.value}
                        options={defaultValue}
                    />
                )}
            </Stack>
        </Grid>
    );
};

export default RenderSelect;
